<template>
  <div id="wallpaper">
    <Navbar />
    <v-container fluid>
      <form @submit.prevent="changePassword">
        <v-text-field
          label="Nueva contraseña"
          type="password"
          v-model="passwords.nueva"
          required
          @change="validatePasswords"
        />
        <PasswordIndicator />
        <v-text-field
          label="Confirmar contraseña"
          type="password"
          v-model="passwords.confirm"
          required
          @change="validatePasswords"
        />

        <v-btn block color="primary" type="submit" :disabled="!match"
          >Enviar</v-btn
        >
      </form>
  </v-container>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import PasswordIndicator from "./PasswordIndicator";

export default Vue.extend({
  name: "RecoveryPassword",
  componente: {
    PasswordIndicator,
  },
  data: () => ({
    passwords: {
      nueva: "",
      confirm: "",
    },
    matchValidator: "Las contraseñas no coinciden",
    match: false,
  }),
  methods: {
    changePassword: async function () {
      const token = this.$route.params.token;
      await axios({
        url: `${process.env.VUE_APP_BACKEND}/change-password/${token}`,
        method: "PUT",
        data: this.passwords,
      })
        .then((res) => {
          // console.log(res)
          this.$awn.success(res.data);
          this.$router.push("/");
        })
        .catch((err) => {
          this.$awn.alert(err.response.data);
          // this.$router.push("/")
        });
    },

    validatePasswords: function () {
      this.match = this.passwords.nueva === this.passwords.confirm;
    },
  },
});
</script>
<style lang="scss" scoped>
#wallpaper {
  background: url("~@/assets/Energy-Efficient-Light-Bulbs.jpg");
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  height: calc(100% - 50px);
  background-size: cover;
}

.container {
  height: 100vh;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

}
.v-card {
  // overflow-y: auto;
  overflow: hidden;
}


</style>